import { render, staticRenderFns } from "./IcoPaperPencil.vue?vue&type=template&id=86236f2a"
import script from "./IcoPaperPencil.vue?vue&type=script&lang=js"
export * from "./IcoPaperPencil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports